var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"login-window-footer"},[_vm._t("default")],2),_vm._v(" "),_c('p',{staticClass:"mt-2"},[_c('small',[_vm._v(_vm._s(_vm.versionText))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }